import { api, setAuthToken, setRefreshToken, URLs } from '@/libs/api'
import type { LoginCredentials, LoginResponse } from '@/libs/interfaces'
import { IS_MOCK_MODE } from '@/libs/mocks/config'
import { authApiMock } from '@/libs/mocks/handlers/auth'

const getRefreshToken = () => localStorage.getItem('refreshToken')

const authApiReal = {
  login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
    return await api.post<LoginResponse>(URLs.LOGIN, credentials).then((response) => {
      const { accessToken, refreshToken } = response.data
      setAuthToken(accessToken)
      if (refreshToken) setRefreshToken(refreshToken)
      return response.data
    })
  },
  logout: async (): Promise<void> => {
    await api.post(URLs.LOGOUT, { refreshToken: getRefreshToken() })
  },
}

export const authApi: typeof authApiReal = IS_MOCK_MODE ? authApiMock : authApiReal
